import { Controller } from '@hotwired/stimulus'

// Coordinates the per-gateway "Enabled" and "Default" toggles:
//   - Exactly one ENABLED gateway is the Default (radio behaviour): switching
//     one Default on turns the other off; switching it off hands Default to the
//     other enabled gateway. You can't leave zero defaults when a gateway is
//     enabled.
//   - A disabled gateway's Default toggle is disabled and forced off; disabling
//     the current default moves Default to the other enabled gateway.
// Server-side normalisation in Backoffice::GatewaySettingsController guarantees
// the same invariant on save (each gateway card is its own form).
export default class extends Controller {
  static targets = ['enabled', 'default']

  connect() {
    this.syncDisabledStyles()
  }

  // User flipped a "Default" toggle.
  defaultChanged(event) {
    const toggle = event.target
    if (toggle.checked) {
      this.defaultTargets.forEach((t) => { if (t !== toggle) t.checked = false })
    } else {
      const other = this.defaultTargets.find((t) => t !== toggle && !t.disabled)
      if (other) {
        other.checked = true            // hand Default to the other enabled gateway
      } else {
        toggle.checked = true           // nothing else can take it — keep it on
      }
    }
  }

  // User flipped an "Enabled" master switch.
  enabledChanged(event) {
    const enabled = event.target
    const card = enabled.closest('[data-gateway-card]')
    const def = card && card.querySelector('[data-gateway-default-toggle-target="default"]')
    if (!def) return

    if (enabled.checked) {
      def.disabled = false
      const anyDefault = this.defaultTargets.some((t) => !t.disabled && t.checked)
      if (!anyDefault) def.checked = true            // ensure exactly one default
    } else {
      const wasDefault = def.checked
      def.checked = false
      def.disabled = true
      if (wasDefault) {
        const other = this.defaultTargets.find((t) => t !== def && !t.disabled)
        if (other) other.checked = true              // move default to the other enabled gateway
      }
    }
    this.syncDisabledStyles()
  }

  syncDisabledStyles() {
    this.defaultTargets.forEach((t) => {
      const label = t.closest('label')
      if (!label) return
      label.classList.toggle('cursor-not-allowed', t.disabled)
      label.classList.toggle('cursor-pointer', !t.disabled)
    })
  }
}
